import { NO_ACCESS } from "./constants";
import { getJobCodeData, getWorkgroupData } from "./employeeConfigUtils";

export function getDefaultUserAccessGiveJobCode(jobCode) {
  const defaultAccessLevel = getJobCodeData()[jobCode].defaultAccessLevel;
  if (!defaultAccessLevel) {
    return NO_ACCESS;
  }
  return defaultAccessLevel;
}

export function getJobTitleGivenJobCode(jobCode) {
  const title = getJobCodeData()[jobCode]?.title;
  return title;
}

export function getWorkgroupGivenJobCode(jobCode) {
  const workgroup = getJobCodeData()[jobCode]?.workgroup;
  return workgroup;
}

export function getEligibleWorkgroupsGivenJobCode(jobCode) {
  const workgroup = getJobCodeData()[jobCode].workgroup;
  const eligibleWorkgroups = getWorkgroupData()[workgroup].eligibleWorkgroups;
  return eligibleWorkgroups;
}

export function getEligibleWorkgroupsForGiveawayTradesGivenJobCode(jobCode) {
  const workgroup = getJobCodeData()[jobCode].workgroup;
  const eligibleGiveawayWorkgroups = getWorkgroupData()[workgroup].eligibleGiveawayWorkgroups;
  return eligibleGiveawayWorkgroups;
}

export function getIsTradeBetweenAgentAndSup(workgroup1, workgroup2) {
  const tradeAgentToSupWorkgroups = getWorkgroupData()[workgroup1].eligibleTradeAgentAndSup;
  return tradeAgentToSupWorkgroups.length === 0 ? false : tradeAgentToSupWorkgroups.includes(workgroup2);
}

export function getEligibleJobCodesGivenWorkgroup(workgroup) {
  let eligibleJobCodes = [];
  const eligibleWorkgroups = getWorkgroupData()[workgroup].eligibleWorkgroups;
  eligibleWorkgroups.forEach((workgroup) => {
    eligibleJobCodes.concat(getWorkgroupData()[workgroup].jobCodes);
  });
  return eligibleJobCodes;
}

export function getEligibleJobCodesForGiveawayTradesGivenWorkgroup(workgroup) {
  let eligibleJobCodes = [];
  const eligibleWorkgroups = getWorkgroupData()[workgroup].eligibleGiveawayWorkgroups;
  eligibleWorkgroups.forEach((workgroup) => {
    eligibleJobCodes.concat(getWorkgroupData()[workgroup].jobCodes);
  });
  return eligibleJobCodes;
}

export function getUnionContractGivenWorkgroup(workgroup) {
  const unionContract = getWorkgroupData()[workgroup].unionContract;
  return unionContract;
}

export function getUnionContractGivenJobCode(jobCode) {
  const unionContract = getJobCodeData()[jobCode].unionContract;
  return unionContract;
}

export function isManager(jobCode) {
  const isManager = getJobCodeData()[jobCode].workgroup === "Manager";
  return isManager;
}

export function isEligibleForAccessOverride(jobCode) {
  const isEligible = getJobCodeData()[jobCode].accessOverrideEligible;
  return isEligible;
}
